<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                placeholder="Введите ФИО"
                v-model="currFilters.patientFio"
                label="Контекстный поиск (Фамилия, Имя, Отчество)"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                placeholder="Введите ФИО"
                v-model="currFilters.representativeFio"
                label="Данные представителя"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Статус</label>
              <select class="form-control" v-model="currFilters.status">
                <option v-bind:value="-1">Все</option>
                <option
                  v-for="el in statusList"
                  v-bind:key="el.id"
                  :value="el.id"
                >
                  {{ el.text }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Район</label>
              <Select2
                class="select2"
                :options="districtList"
                v-model="currFilters.addressDistrictId"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>МО прикрепления</label>
              <Select2
                class="select2"
                :options="medOrgs"
                v-model="currFilters.medOrgIds"
                :settings="{ multiple: true, placeholder: '-- не выбрано --' }"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex">
        <button-component class="col-6" @click="apply">
          Применить
        </button-component>
        <button-component class="col-6" kind="secondary" @click="reset">
          Сбросить
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import { ru } from "date-fns/locale";
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import Utils from "@/common/utils";
import Constants from "@/common/constants";
import Api from "../api/poll";

export default {
  name: "TmpPatientsFilters",
  components: { ComponentInput, ButtonComponent },
  props: {
    filters: Object,
  },
  data() {
    return {
      locale: ru,
      statusList: [],
      districtList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      medOrgs: [],
      currFilters: this.filters,
    };
  },
  methods: {
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        patientFio: "",
        status: -1,
        representativeFio: "",
        addressDistrictId: 0,
        medOrgIds: [],
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
  },
  created() {
    Utils.loadSelectOptions("tmpPatientStatus", this.statusList);
    Utils.loadSelectOptions("district", this.districtList, {
      regionId: Constants.regionNizhnyNovgorodId,
    });
    Api.getMedOrgs().then((response) => {
      this.medOrgs = response.data;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}

:deep(.select2-selection--multiple .select2-selection__choice) {
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
</style>
